import ApplicationController from './application_controller'

export default class extends ApplicationController {
  static targets = ["form", "submitButton", "errorMessage"]
  static values = {
    publishableKey: String,
    paymentIntentId: String,
    clientSecret: String
  }

  connect() {
    console.log('Review controller connected')

    // Make sure submit button is enabled for the review step
    const submitButton = this.getSubmitButton()
    if (submitButton) {
      submitButton.disabled = false
    }
  }

  // Get the submit button - may be outside controller scope on mobile due to navigation repositioning
  getSubmitButton() {
    if (this.hasSubmitButtonTarget) {
      return this.submitButtonTarget
    }
    // Fallback: search in mobile nav placeholder
    const mobileNav = document.getElementById('mobile-nav-placeholder')
    if (mobileNav) {
      return mobileNav.querySelector('[data-review-target="submitButton"]')
    }
    return null
  }

  // Handle form submission
  async handleSubmit(event) {
    const submitButton = this.getSubmitButton()
    if (!submitButton) {
      return // Let default form submission proceed if no button found
    }

    // Update button state to show processing
    submitButton.disabled = true
    submitButton.innerHTML = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Processing...'

    // Let the form submit normally to process payment on server
    // No need to prevent default or do any Stripe operations here
  }

  // Show error message if needed
  showError(message) {
    if (this.hasErrorMessageTarget) {
      this.errorMessageTarget.textContent = message
      this.errorMessageTarget.classList.remove('hidden', 'd-none')
    } else {
      console.error('Error message:', message)
      alert(message) // Fallback if target not found
    }
  }
}
